class Accordion {
    constructor() {
        this.classes = {
        	trigger: ".js-faq-container",
        	item: ".faqitem__item",
			body: ".faqitem__content",
			click: ".faqitem__title"
        }
        this.properties = {
            "locked": false,
            "delay": 300
        }

        this.element = document.querySelector(this.classes.trigger)
        this.content = document.querySelector(this.classes.body)
        this.title = document.querySelector(this.classes.click)


        if (this.element){
            this.items = this.element.querySelectorAll(this.classes.item)
            this.initialize()
        }



    }

    convertToPixels(number) {
        return [number, "px"].join("")
	}
    getItemHeight (item) {
        let body = item.querySelector(this.classes.body), 
            originalProperty = body.style.display
        body.style.display = "block"
        let height = body.clientHeight
        body.style.display = originalProperty
        return height
    }
    closeItem (item, body) {
        let self = this
        item.classList.remove("is-active")
        body.style.height = this.convertToPixels(0)
        setTimeout(function () {
            body.style.display = "none"
            body.style.height = ""
            self.properties.locked = false
        }, this.properties.delay)
    }
    closeItems (exclude) {
        for (let i = 0; i < this.items.length; i++) {
            if (exclude.indexOf(this.items[i]) !== -1) {
                continue
            }
            let item = this.items[i],
                body = item.querySelector(this.classes.body) // faq-accordion__item__body
            if (body.style.display === "block") {
                this.closeItem(item, body)
            }
        }
    }
    toggleItem (item) {

        if (this.properties.locked) {
            return
        }
        let body = item.querySelector(this.classes.body) // faq-accordion__item__body
        this.properties.locked = true
        if (body.style.display !== "block") {
            let self = this
            this.closeItems([item])
            let newItemHeight = this.getItemHeight(item)
            item.classList.add("is-active")
            body.style.height = this.convertToPixels(0)
            body.style.display = "block"
            window.requestAnimationFrame(function () {
                body.style.height = self.convertToPixels(newItemHeight)
                setTimeout(function () {
                    self.properties.locked = false
                }, self.properties.delay)
            })
        } else {
            this.closeItem(item, body)
        }
    }
    initialize () {
        let self = this
        for (let i = 0; i < this.items.length; i++) {
            let item = this.items[i],
                header = item.querySelector(this.classes.click) // faq-accordion__item__header
			header.addEventListener("click", function (e) {
                e.preventDefault()
                self.toggleItem(item)
            })
        }
    }
}

export default Accordion

 